import { useState } from 'react';
import { PHONE_VALIDATION } from '../constants/utils/UtilConstants';
const emailIdrRegEx = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

/**
 * Custom hook for validating email/phone input and CAPTCHA token.
 * @param {string} emailOrPhone - The input email or phone number
 * @param {string} captchaToken - CAPTCHA token
 */
export const useEmailOrPhoneNumberValidationWithCaptcha = (emailOrPhone, captchaToken) => {
  const [validationError, setValidationError] = useState(null);

  // Enhanced validation function
  const validatePhoneNumber = (input) => {
    const phoneNumber = input.startsWith(PHONE_VALIDATION.PREFIXES.PLUS) ? input.slice(1) : input;

    // Check for UK phone numbers
    if (input.startsWith(PHONE_VALIDATION.COUNTRY_CODES.UK) || input.startsWith('0')) {
      if (!PHONE_VALIDATION.REGEX.UK.test(input)) {
        setValidationError(PHONE_VALIDATION.MESSAGES.INVALID_UK_PHONE);
        return false;
      }
      return true;
    }

    // Check for India phone numbers
    if (input.startsWith(PHONE_VALIDATION.COUNTRY_CODES.INDIA)) {
      if (!PHONE_VALIDATION.REGEX.INDIA.test(input)) {
        setValidationError(PHONE_VALIDATION.MESSAGES.INVALID_INDIA_PHONE);
        return false;
      }
      return true;
    }

    // Generic phone validation (10-15 digits)
    if (!PHONE_VALIDATION.REGEX.DIGITS_ONLY.test(phoneNumber)) {
      setValidationError(PHONE_VALIDATION.MESSAGES.INVALID_PHONE);
      return false;
    }
  };

  const validateInput = () => {
    const input = emailOrPhone.trim();

    if (!input) {
      setValidationError('This field is required');
      return false;
    }

    const isEmail = isNaN(input);
    if (isEmail && !emailIdrRegEx.test(input)) {
      setValidationError('Invalid email address');
      return false;
    }

    if (!isEmail) {
        const isValidPhone = validatePhoneNumber(input);
        if (!isValidPhone) return false;
    }

    if (!captchaToken) {
      setValidationError('Please complete the CAPTCHA');
      return false;
    }

    setValidationError(null);
    return true;
  };

  return { validationError, validateInput, validatePhoneNumber };
};
